import { useDevice } from '@/hooks/use-device';
import { mapControlClassName } from '@/utils/map';
import { ControlPosition, MapControl } from '@vis.gl/react-google-maps';
import { Expander } from '../expander/expander';
import classes from './legend-control.module.css';

/**
 * @param {object} props
 * @param {React.ReactNode} props.children
 * @returns {React.JSX.Element}
 */
export function LegendControl({ children }) {
  const { isMobile } = useDevice();
  return (
    <MapControl position={ControlPosition.LEFT_BOTTOM}>
      <div className={`${mapControlClassName} ${classes.legend}`}>
        <Expander title={isMobile ? 'Legend' : undefined} isExpandable={isMobile} classes={{ title: classes.title }}>
          <div className={classes.content}>{children}</div>
        </Expander>
      </div>
    </MapControl>
  );
}
